var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isViewer
    ? _c(
        "div",
        { attrs: { id: "deliveryConfirm" } },
        [
          _c("dd-header", { attrs: { isMenuView: false } }),
          _vm._v(" "),
          _c("dd-sitemap", {
            attrs: { pageKey: _vm.pageKey, pageList: _vm.orderForm.pageList }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { attrs: { id: "content" } },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.nowList, function(itemData, index) {
                  return _c("dd-item-confirm", {
                    key: "cart-item-confirm-" + index,
                    attrs: { itemData: itemData, index: index + Number(1) },
                    on: { onShowEstimateModal: _vm.onShowEstimateModal }
                  })
                }),
                _vm._v(" "),
                _c("section", { attrs: { id: "totalPrice" } }, [
                  _c("h3", { staticClass: "bold" }, [_vm._v("注文情報")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input_list" }, [
                    _c("ul", [
                      _c("li", [
                        _c("table", { staticClass: "order_price_table" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", { staticClass: "b_separator" }, [
                              _c("td", [_vm._v("商品・配送料小計")]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatPrice(
                                      _vm.cartData.cartModel.orderPrice
                                        .itemSubTotalPrice
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("消費税")]),
                              _vm._v(" "),
                              _c("td", [_vm._v("10%")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatPrice(
                                      _vm.cartData.cartModel.orderPrice
                                        .itemSubTotalTax
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", { staticClass: "n_separator" }, [
                              _c("td", [_vm._v("商品・配送費合計")]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatPrice(
                                      _vm.cartData.cartModel.orderPrice
                                        .itemTotalPrice
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "table",
                          {
                            staticClass: "order_price_table",
                            staticStyle: { "margin-top": "20px" }
                          },
                          [
                            _c(
                              "tbody",
                              [
                                _vm.isConstruct
                                  ? [
                                      _c(
                                        "tr",
                                        {
                                          staticClass: "b_separator tbl_space"
                                        },
                                        [
                                          _c("td", [
                                            _vm._v("組立設置他サービス費小計")
                                          ]),
                                          _vm._v(" "),
                                          _c("td"),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatPrice(
                                                  _vm.cartData.cartModel
                                                    .orderPrice.optSubTotalPrice
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.cartData.cartModel.orderPrice
                                        .discntPrice
                                        ? _c("tr", [
                                            _c("td", [_vm._v("諸経費割引")]),
                                            _vm._v(" "),
                                            _c("td"),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "(-" +
                                                  _vm._s(
                                                    _vm.formatPrice(
                                                      _vm.cartData.cartModel
                                                        .orderPrice.discntPrice
                                                    )
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.cartData.cartModel.orderPrice
                                        .discntPrice
                                        ? _c(
                                            "tr",
                                            { staticClass: "n_separator" },
                                            [
                                              _c("td", [_vm._v("割引後小計")]),
                                              _vm._v(" "),
                                              _c("td"),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatPrice(
                                                      _vm.cartData.cartModel
                                                        .orderPrice
                                                        .discntSubTotalPrice
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("td", [_vm._v("消費税")]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("10%")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatPrice(
                                                _vm.cartData.cartModel
                                                  .orderPrice.optTotalTax
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", { staticClass: "n_separator" }, [
                                        _c("td", [
                                          _vm._v("組立設置他サービス費合計")
                                        ]),
                                        _vm._v(" "),
                                        _c("td"),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatPrice(
                                                _vm.cartData.cartModel
                                                  .orderPrice.optTotalPrice
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "table",
                          {
                            staticClass: "order_price_table",
                            staticStyle: { "margin-top": "20px" }
                          },
                          [
                            _c(
                              "tbody",
                              [
                                [
                                  _c("tr", { staticClass: "b_separator" }, [
                                    _c("td", [_vm._v("ご請求額合計")]),
                                    _vm._v(" "),
                                    _c("td"),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatPrice(
                                            _vm.cartData.cartModel.orderPrice
                                              .totalPrice
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.orderForm.person &&
                Object.keys(_vm.orderForm.person).length > 0
                  ? _c("section", { attrs: { id: "person" } }, [
                      _c("h3", { staticClass: "text_size_big bold" }, [
                        _vm._v("担当者情報")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_confirm3" }, [
                        _c("ul", [
                          _c("li", [
                            _c("span", [_vm._v("店舗名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.orderForm.person.cofficeName))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("担当者名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.orderForm.person.userData.cuserLastName
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.orderForm.person.userData.cuserFirstName
                                  )
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("section", { attrs: { id: "owner" } }, [
                  _c("h3", { staticClass: "text_size_big bold" }, [
                    _vm._v("発注者情報")
                  ]),
                  _vm._v(" "),
                  !_vm.isGuestUser
                    ? _c("div", { staticClass: "input_confirm3" }, [
                        _c("ul", [
                          _c("li", [
                            _c("span", [_vm._v("発注者企業名：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.userData.corpName))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("郵便番号：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.userData.postcd))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("発注者住所：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.userData.state) +
                                  " " +
                                  _vm._s(_vm.userData.city)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("以下、住所：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.userData.street))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("発注者氏名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.userData.userLastName) +
                                  " " +
                                  _vm._s(_vm.userData.userFirstName)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("（カナ）：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.userData.userLastNameKana) +
                                  " " +
                                  _vm._s(_vm.userData.userFirstNameKana)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("電話番号：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.userData.tel))])
                          ])
                        ])
                      ])
                    : _c("div", { staticClass: "input_confirm3" }, [
                        _c("ul", [
                          _c("li", [
                            _c("span", [_vm._v("発注者氏名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.userData.userLastName) +
                                  " " +
                                  _vm._s(_vm.userData.userFirstName)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("（カナ）：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.userData.userLastNameKana) +
                                  " " +
                                  _vm._s(_vm.userData.userFirstNameKana)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("電話番号：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.userData.tel))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("メールアドレス：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.userData.email))])
                          ])
                        ])
                      ])
                ]),
                _vm._v(" "),
                !_vm.orderForm.isCarryIn
                  ? _c("section", { attrs: { id: "delivery" } }, [
                      _c("h3", { staticClass: "text_size_big bold" }, [
                        _vm._v("納品先情報")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_confirm3" }, [
                        _c("ul", [
                          _c("li", [
                            _c("span", [_vm._v("施主名(物件名)：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.deliveryData.businessName))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("納品先名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.deliveryData.building))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("郵便番号：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.deliveryData.postcd))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("納品先住所：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.deliveryData.state) +
                                  " " +
                                  _vm._s(_vm.deliveryData.city)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("以下、住所：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.deliveryData.street))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("受取人氏名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.deliveryData.userLastName) +
                                  " " +
                                  _vm._s(_vm.deliveryData.userFirstName)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("（カナ）：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.deliveryData.userLastNameKana) +
                                  " " +
                                  _vm._s(_vm.deliveryData.userFirstNameKana)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("電話番号：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.deliveryData.tel))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("納品希望日： ")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getViewDate(_vm.deliveryData.deliveryDate)
                                ) +
                                  " " +
                                  _vm._s(_vm.getViewTime())
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("配送時の連絡事項：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.deliveryData.message))
                            ])
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderForm.workFlag
                  ? _c("section", { attrs: { id: "struct" } }, [
                      _c("h3", { staticClass: "text_size_big bold" }, [
                        _vm._v("組立設置情報")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_confirm3" }, [
                        _c("ul", [
                          _vm.structData.businessName
                            ? _c("li", [
                                _c("span", [_vm._v("施主名(物件名)：")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.structData.businessName))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("郵便番号：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.structData.postcd))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("設置先住所：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.structData.state) +
                                  _vm._s(_vm.structData.city)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("以下、住所：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.structData.street))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("立会人氏名：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.structData.userLastName) +
                                  " " +
                                  _vm._s(_vm.structData.userFirstName)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("（カナ）：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.structData.userLastNameKana) +
                                  " " +
                                  _vm._s(_vm.structData.userFirstNameKana)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("立会人電話番号：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.structData.tel))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("第一作業希望日：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getViewDate(_vm.structData.desiredDate1st)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("第二作業希望日：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getViewDate(_vm.structData.desiredDate2nd)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("第三作業希望日：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getViewDate(_vm.structData.desiredDate3rd)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("ご自宅のタイプ：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.homeType))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("駐車場の有無：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.parkingSpace))])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", [_vm._v("組立設置の連絡事項：")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.structData.message))])
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.userData.isAccountPay
                  ? _c(
                      "section",
                      [
                        _c("h3", { staticClass: "text_size_big bold" }, [
                          _vm._v("注意事項")
                        ]),
                        _vm._v(" "),
                        _c("dd-payment-caution")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("section", { attrs: { id: "deli_confirm" } }, [
                  _c("h3", { staticClass: "text_size_big bold" }, [
                    _vm._v("確認事項")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input_list" }, [
                    _c("div", { staticClass: "check_box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmUseRule,
                            expression: "confirmUseRule"
                          }
                        ],
                        attrs: { type: "checkbox", id: "confirmUseRule" },
                        domProps: {
                          checked: Array.isArray(_vm.confirmUseRule)
                            ? _vm._i(_vm.confirmUseRule, null) > -1
                            : _vm.confirmUseRule
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.confirmUseRule,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.confirmUseRule = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.confirmUseRule = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.confirmUseRule = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "confirmUseRule" } }, [
                        _c(
                          "a",
                          { staticClass: "link" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "link",
                                attrs: {
                                  to: "/mmstyle/user/use-rule",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("利用規約")]
                            )
                          ],
                          1
                        ),
                        _vm._v("に同意しました。")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "check_box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmItem,
                            expression: "confirmItem"
                          }
                        ],
                        attrs: { type: "checkbox", id: "confirmItem" },
                        domProps: {
                          checked: Array.isArray(_vm.confirmItem)
                            ? _vm._i(_vm.confirmItem, null) > -1
                            : _vm.confirmItem
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.confirmItem,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.confirmItem = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.confirmItem = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.confirmItem = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "confirmItem" } }, [
                        _vm._v("商品仕様を確認しました。")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "check_box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmOrderCancel,
                            expression: "confirmOrderCancel"
                          }
                        ],
                        attrs: { type: "checkbox", id: "confirmOrderCancel" },
                        domProps: {
                          checked: Array.isArray(_vm.confirmOrderCancel)
                            ? _vm._i(_vm.confirmOrderCancel, null) > -1
                            : _vm.confirmOrderCancel
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.confirmOrderCancel,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.confirmOrderCancel = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.confirmOrderCancel = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.confirmOrderCancel = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "emphasis",
                          attrs: { for: "confirmOrderCancel" }
                        },
                        [
                          _vm._v(
                            "注文後のキャンセル及び仕様変更ができないことに同意しました。"
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "check_box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmOrderDeliCancel,
                            expression: "confirmOrderDeliCancel"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "confirmOrderDeliCancel"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.confirmOrderDeliCancel)
                            ? _vm._i(_vm.confirmOrderDeliCancel, null) > -1
                            : _vm.confirmOrderDeliCancel
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.confirmOrderDeliCancel,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.confirmOrderDeliCancel = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.confirmOrderDeliCancel = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.confirmOrderDeliCancel = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "emphasis",
                          attrs: { for: "confirmOrderDeliCancel" }
                        },
                        [
                          _vm._v(
                            "納品日及び納品先の変更、納品日の短縮ができないことに同意しました。"
                          )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.mkid === 1
                  ? _c("section", [
                      _c("h3", { staticClass: "text_size_big bold" }, [
                        _vm._v("配送時の確認事項")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_list confirmDeliArea" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "check_box" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.confirmDelivery,
                                expression: "confirmDelivery"
                              }
                            ],
                            attrs: { type: "checkbox", id: "confirmDelivery" },
                            domProps: {
                              checked: Array.isArray(_vm.confirmDelivery)
                                ? _vm._i(_vm.confirmDelivery, null) > -1
                                : _vm.confirmDelivery
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.confirmDelivery,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.confirmDelivery = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.confirmDelivery = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.confirmDelivery = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "emphasis",
                              attrs: { for: "confirmDelivery" }
                            },
                            [_vm._v("配送時の注意事項を確認しました。")]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("section", { attrs: { id: "form_button" } }, [
                  _c("div", { staticClass: "control_btn_area" }, [
                    _c(
                      "div",
                      { staticClass: "detail_btn2", on: { click: _vm.reEdit } },
                      [_vm._v("〈〈   戻る   ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          detail_btn: true,
                          disabled: _vm.isOrderDisable
                        },
                        on: { click: _vm.payment }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.payTypeLabel) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    attrs: {
                      name: "ecform",
                      action: _vm.ecsiteUrl,
                      method: "post",
                      "accept-charset": _vm.chatset
                    }
                  },
                  [
                    _c(
                      "div",
                      _vm._l(Object.entries(_vm.ecData), function(ref) {
                        var key = ref[0]
                        var val = ref[1]
                        return _c("input", {
                          key: "paygent_req_" + key,
                          attrs: { type: "hidden", name: key },
                          domProps: { value: val }
                        })
                      })
                    )
                  ]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("dd-loading-modal", { ref: "loadingModalRef" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("ご注文内容確認")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("項目")]),
        _vm._v(" "),
        _c("th", [_vm._v("単価")]),
        _vm._v(" "),
        _c("th", [_vm._v("金額")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n            ■ 集合住宅や店舗などの場合"),
      _c("br"),
      _vm._v("\n            エレベーターがある場合 : 玄関前渡し"),
      _c("br"),
      _vm._v("\n            エレベーターが無い場合 : 共有部エントランス前渡し"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n            ■ 戸建の場合"),
      _c("br"),
      _vm._v("\n            玄関前渡し"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n            いずれの場合も原則置き便は出来ません。受取人様をご指定ください。"
      ),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aa2396e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa2396e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcOrderConfirm.vue
// module id = null
// module chunks = 